<div class="page-header">
  <a routerLink="/redirects/overzicht" class="page-header__back">
    <i class="fa-regular fa-chevron-left"></i>
  </a>
  <h1 class="page-header__title">{{ "redirects.title" | translate }}</h1>
  <div class="page-header__actions"></div>
</div>

<app-redirect-detail-form
  [redirect]="redirect$ | async"
  (submitted)="submit($event)"
  (modalSubmitted)="modalSubmit($event)"
  [errors]="errors$ | async"
  [loading]="loading$ | async"
  [slugExists$]="slugExists$!"
  (resetSlugExists)="resetSlugExists()"
/>
